<template>
    <span>
        <el-button size="small" v-bind="$attrs" class="yl-button" v-if="isShow.status && buttonType.includes($attrs.type)">
            <svg v-if="icon == 'template'" t="1621928451590" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4844" width="14" height="14"><path d="M903.808 960H51.52a31.232 31.232 0 0 1-30.464-32v-320c0-17.664 13.632-32 30.464-32s30.4 14.336 30.4 32V896h791.424V608c0-17.664 13.632-32 30.464-32s30.464 14.336 30.464 32v320c0 17.664-13.632 32-30.464 32z" p-id="4845"></path><path d="M782.08 832H173.248a31.232 31.232 0 0 1-30.4-32v-704c0-17.664 13.632-32 30.4-32h608.832c16.768 0 30.4 14.336 30.4 32v704c0 17.664-13.632 32-30.4 32z m-578.368-64h547.84V128h-547.84v640z" p-id="4846"></path><path d="M629.824 288H325.44A31.232 31.232 0 0 1 295.04 256c0-17.664 13.632-32 30.4-32h304.384c16.832 0 30.464 14.336 30.464 32s-13.632 32-30.464 32z m0 192H325.44A31.232 31.232 0 0 1 295.04 448c0-17.664 13.632-32 30.4-32h304.384c16.832 0 30.464 14.336 30.464 32s-13.632 32-30.464 32z m0 192H325.44a31.232 31.232 0 0 1-30.4-32c0-17.664 13.632-32 30.4-32h304.384c16.832 0 30.464 14.336 30.464 32s-13.632 32-30.464 32z" p-id="4847"></path></svg>
            <svg v-if="icon == 'export'" t="1621928519782" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4988" width="14" height="20"><path d="M894.592 532.288a31.68 31.68 0 0 0-31.68 31.68v251.008c0 23.296-19.008 42.304-42.304 42.304h-616.96a42.368 42.368 0 0 1-42.24-42.24V233.664c0-23.36 19.008-42.304 42.24-42.304h270.72a31.68 31.68 0 0 0 0-63.424h-270.72c-58.24 0-105.6 47.36-105.6 105.728v581.248c0 58.304 47.36 105.728 105.6 105.728h616.96c58.24 0 105.664-47.36 105.664-105.728V564.032a31.68 31.68 0 0 0-31.68-31.744zM253.12 688.896c98.496-93.184 197.888-237.312 373.696-227.968 12.416 0.64 22.08 10.368 22.08 22.848v60.992c-0.128 19.2 22.208 29.952 37.12 17.856l227.84-184.32a22.784 22.784 0 0 0 0-35.52L686.912 138.88c-14.848-12.032-38.08-1.408-38.208 17.664v61.824c0 11.584-7.872 19.968-19.264 22.592-302.528 68.992-379.008 423.616-376.384 448z" :fill="toggleStatus ? '#288CE9':'#606266'" p-id="4989"></path></svg>
            <svg v-if="icon == 'import'" t="1621931894897" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5130" width="14" height="20"><path d="M129.408 532.288c17.472 0 31.68 14.208 31.68 31.68v251.008c0 23.296 19.008 42.304 42.304 42.304h616.96c23.232 0 42.24-19.008 42.24-42.24V233.664a42.368 42.368 0 0 0-42.24-42.304h-270.72a31.68 31.68 0 0 1 0-63.424h270.72c58.24 0 105.6 47.36 105.6 105.728v581.248c0 58.304-47.36 105.728-105.6 105.728h-616.96c-58.24 0-105.664-47.36-105.664-105.728V564.032c0-17.536 14.144-31.744 31.68-31.744zM43.328 225.344c126.08 49.92 298.688 79.104 364.544 242.368a22.912 22.912 0 0 1-11.392 29.696l-55.296 25.792a22.784 22.784 0 0 0-0.448 41.152l263.36 128.64c12.992 6.4 28.672-0.896 32.128-15.104l88.96-291.776c4.608-18.56-14.72-35.072-32.128-27.136l-56 26.112c-10.496 4.928-21.504 1.28-28.672-7.936-190.336-244.992-544-164.48-565.12-151.808z" :fill="toggleStatus ? '#288CE9':'#606266'" p-id="5131"></path></svg>
            <svg v-if="icon == 'upload'" t="1621931926361" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5272" width="14" height="20"><path d="M906.688 619.456c16 0 30.208 13.184 31.808 28.992l0.192 3.008v213.312c0 39.168-31.936 72.384-70.656 74.56l-4.032 0.128h-704a75.648 75.648 0 0 1-74.56-70.656l-0.128-4.032v-213.376c0-17.024 14.976-32 32-32 16.064 0 30.272 13.248 31.872 29.056l0.128 2.944v213.376c0 5.696 3.392 9.664 8.64 10.496l2.048 0.192h704c5.696 0 9.664-3.392 10.496-8.64l0.192-2.048v-213.312c0-17.088 14.912-32 32-32zM512 713.28a32 32 0 0 0 32-32V167.04l216.896 216.896a32 32 0 0 0 47.488-42.88l-2.24-2.368L564.8 97.28a74.688 74.688 0 0 0-102.4-3.008l-3.2 3.008-241.344 241.408a32 32 0 0 0 42.816 47.424l2.432-2.176L480 166.976v514.304a32 32 0 0 0 32 32z" :fill="toggleStatus ? '#288CE9':'#606266'" p-id="5273"></path></svg>
            <svg v-if="icon == 'download'" t="1621931966829" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5414" width="14" height="20"><path d="M906.688 619.456c16 0 30.208 13.184 31.808 28.992l0.192 3.008v213.312c0 39.168-31.936 72.384-70.656 74.56l-4.032 0.128h-704a75.648 75.648 0 0 1-74.56-70.656l-0.128-4.032v-213.376c0-17.024 14.976-32 32-32 16.064 0 30.272 13.248 31.872 29.056l0.128 2.944v213.376c0 5.696 3.392 9.664 8.64 10.496l2.048 0.192h704c5.696 0 9.664-3.392 10.496-8.64l0.192-2.048v-213.312c0-17.088 14.912-32 32-32zM512 75.456a32 32 0 0 1 32 32v514.24l216.896-216.896a32 32 0 0 1 47.488 42.816l-2.24 2.432-241.344 241.344a74.688 74.688 0 0 1-102.4 3.008l-3.2-2.944-241.344-241.408a32 32 0 0 1 42.816-47.424l2.432 2.176L480 621.76V107.392a32 32 0 0 1 32-32z" :fill="toggleStatus ? '#288CE9':'#606266'" p-id="5415"></path></svg>
            <div v-html="label" v-if="dataSource? dataSource.isHtml:'false'"></div>
            <div v-else>{{label}}</div>
        </el-button>
        <el-checkbox v-model="value" v-if="$attrs.type == 'checkbox'" v-bind="$attrs" @change="changeChecked">{{label}}</el-checkbox>
    </span>
</template>
<script>
export default {
    name:'yl-lc-button',
    props:{
        name:{
            type:String,
            default:"按钮"
        },
        icon:{
            type:String,
            default:""
        },
        isShow:{
            type:Object,
            default:()=>{
                return {
                    status:true,
                    isAction:true,
                    body:""
                }
            }
        },
        dataSource: {
            type: Object,
            defalut: {}
        },
        scope: {
            type: Object,
            defalut: {}
        }
    },
    watch:{
        "dataSource":{
            handler(data,_oldVal){
                if(data !== undefined && data.body) {
                    if(data.isHtml){
                        this.label = window.LOWCODE.source ? this.$lowcode.createMatchTextHtml(data.body,this.scope) : this.$store.getters.getTextHtml(data.body)
                    }else{
                        this.label = window.LOWCODE.source ? this.$lowcode.createMatchField(data.body,this.scope) : this.$store.getters.getSourceVal(data.body);
                    }
                }
            },
            immediate: true,
        },
        "name":{
            handler(data,_oldVal){
                if(this.dataSource !== undefined) {
                    if(this.dataSource.isHtml){
                        this.label = window.LOWCODE.source ? this.$lowcode.createMatchTextHtml(this.dataSource.body,this.scope) : this.$store.getters.getTextHtml(this.dataSource.body)
                    }else{
                        this.label = window.LOWCODE.source ? this.$lowcode.createMatchField(this.dataSource.body || data,this.scope) : this.$store.getters.getSourceVal(this.dataSource.body || data);
                    }
                }else{
                    this.label = data
                }
            },
            immediate: true,
        }
    },
    data() {
        return {
            buttonType:["primary","text"],
            value:false,
            toggleStatus:false,
            label: this.name,
        }
    },
    computed: {
        
    },
    methods: {
        changeChecked(val){
            this.$emit("change",{
                value:val,
                event:this.$attrs.data
            });
        }
    },
}
</script>
<style lang="less" scope>
.el-button{
    margin-left: 8px;
}
.yl-button.el-button{
    line-height: 17px;
    svg{
        height: 20px;
    }
    &.el-button--primary{
        svg path {fill: #FFFFFF;}
    }
    &.el-button--primary.is-plain{
        svg path {fill: #179CFF !important;}
        &:hover svg path {fill: #ffffff !important;}
        &:focus svg path {fill: #ffffff !important;}
    }
    &.el-button--text{
        &.is-plain{
            color: #606266;
            svg path {fill: #606266 !important;}
            &:hover, &:focus{
                color:  #66b1ff !important;
                svg path {fill: #66b1ff !important;}
            }
        }
    }
    .icon{
        float: left;
        margin-right: 4px;
    }
    &.el-button--small{
        padding: 8px 15px;
    }
}
</style>